import client from '@/lib/request-v2'

export default {
  generateAuthSignature() {
    return client.get<{ sign: string; sign_time: string }>('/integration/sign')
  },
}
